import TranslationText from '@Components/Utilities/TranslationText';
import { useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';

const JobListing = (props) => {
    return (
        <div className={'job-listing ' + (props.UseNewLayoutForJobsandIndustries ? 'logo-format' : 'old-layout')}>
            {props.JobLogoURL && <LazyLoadImage src={props.JobLogoURL} className={'job-logo' + (props.JobLogoURL.indexOf('clear.gif') > -1 ? ' no-logo' : '')} alt={props.EmployerName} />}   
            <div className='job-left'>
                <a href={props.DetailsUrl}>{props.JobTitle}</a>
                <TruncatedDescription fullDescription={props.FullListPageDescription} trimmedDescription={props.PartialListPageDescription} showMoreButton={props.UseNewLayoutForJobsandIndustries} />
                <div className='job-specs'>
                    {props.IndustryCategoryName &&
                        <>
                        <strong><TranslationText tKey='sandhills.industry' />:</strong> {props.IndustryCategoryName}<br />
                        </>}
                    {props.CategoryName &&
                        <>
                        <strong><TranslationText tKey='sandhills.tradesites.mvc.jobcategory' />:</strong> {props.CategoryName}<br />
                        </>}
                    {props.EmploymentTypes &&
                        <>
                        <strong><TranslationText tKey='sandhills.tradesites.mvc.typeofemployment' />:</strong> {props.EmploymentTypes}<br />
                        </>}
                    {props.JobSpecs['EducationRequired'] &&
                        <>
                        <strong><TranslationText tKey='sandhills.tradesites.mvc.minimumeducationrequired' />:</strong> {props.JobSpecs['EducationRequired']}<br />
                        </>}
                    {props.PayType &&
                        <>
                        <strong><TranslationText tKey='sandhills.tradesites.mvc.payrate' />:</strong> {props.PayType} ({props.MinPay} - {props.MaxPay})
                        </>}
                </div>
            </div>
            <div className='job-right'>
                <a href='#'>{props.EmployerName}</a><br />
                {(props.EmployerName != props.ContactName) &&
                    <>
                    <strong><TranslationText tKey='sandhills.contact' />:</strong> {props.ContactName}<br />
                    </>}
                {props.ContactPhone &&
                    <>
                        <a className='job-listings-phone-call' href={'tel:' + props.ContactPhone}>{props.ContactPhone}</a><br />
                    </>}
                {props.JobLocation}<br />
                <a className='job-btn' href={props.DetailsUrl}><TranslationText tKey='sandhills.viewdetails' /></a>
            </div>
        </div>
    );
};

const TruncatedDescription = (props) => {
    const [showMore, setShowMore] = useState(true);
    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: 
                    showMore && props.fullDescription.length > props.trimmedDescription.length ? props.trimmedDescription : props.fullDescription
                }}>
            </p>
            {props.showMoreButton && props.fullDescription.length > props.trimmedDescription.length &&
                <a className='view-more-btn' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setShowMore(!showMore); } }} onClick={() => { setShowMore(!showMore) }}> {showMore ? <TranslationText tKey='sandhills.viewmore' /> : <TranslationText tKey='sandhills.viewless' />}</a>
            }
        </>
    )
}

export default JobListing;